import * as DocumentPicker from 'expo-document-picker';
import React from 'react';
import { View } from 'react-native';
import { scale } from '../../Styles';

import { StudentResultsUploadProps } from '../containers/StudentResultsUploadContainer';
import { MNOHSButton } from '../MNOHSButton';
import { MNOHSDashboardWrapper } from '../MNOHSDashboardWrapper';
import { MNOHSUploadField } from '../MNOHSUploadField';

export const StudentResultsUploadScreen: React.FC<StudentResultsUploadProps> = ({
  files,
  buttonState,
  userChoseDocument,
  userClickedProcess,
}) => {
  return (
    <MNOHSDashboardWrapper
      headerTitle={'Upload Student Results'}
      padded={true}
      parentComponentType={'View'}
      childContainerStyle={{ justifyContent: 'space-between' }}>
      {/* This View component anchors the fields to the top */}
      <View>
        <MNOHSUploadField
          title={'Student Transcript Data'}
          value={files.studentTranscriptData?.type === 'success' ? files.studentTranscriptData.name : ''}
          onPress={async () => {
            const pickedFile = await DocumentPicker.getDocumentAsync({ type: 'text/csv' });
            if (pickedFile.type === 'success') {
              userChoseDocument({ ...files, studentTranscriptData: pickedFile });
            }
          }}
        />
        <MNOHSUploadField
          title={'Student GPA and Rank'}
          value={files.studentGpaAndRank?.type === 'success' ? files.studentGpaAndRank.name : ''}
          onPress={async () => {
            const pickedFile = await DocumentPicker.getDocumentAsync({ type: 'text/csv' });
            if (pickedFile.type === 'success') {
              userChoseDocument({ ...files, studentGpaAndRank: pickedFile });
            }
          }}
        />
        <MNOHSUploadField
          title={'Student Grade'}
          value={files.studentGrade?.type === 'success' ? files.studentGrade.name : ''}
          onPress={async () => {
            const pickedFile = await DocumentPicker.getDocumentAsync({ type: 'text/csv' });
            if (pickedFile.type === 'success') {
              userChoseDocument({ ...files, studentGrade: pickedFile });
            }
          }}
        />
      </View>

      {/* for some reason, if you separate the style, it doesn't work */}
      <MNOHSButton
        state={buttonState}
        style={{ marginTop: scale(20), marginBottom: scale(60) }}
        title={'PROCESS'}
        onPress={userClickedProcess}
      />
    </MNOHSDashboardWrapper>
  );
};
